import { render, staticRenderFns } from "./staffPermission.vue?vue&type=template&id=431cd096&scoped=true"
import script from "./staffPermission.vue?vue&type=script&lang=js"
export * from "./staffPermission.vue?vue&type=script&lang=js"
import style0 from "./staffPermission.vue?vue&type=style&index=0&id=431cd096&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431cd096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('431cd096')) {
      api.createRecord('431cd096', component.options)
    } else {
      api.reload('431cd096', component.options)
    }
    module.hot.accept("./staffPermission.vue?vue&type=template&id=431cd096&scoped=true", function () {
      api.rerender('431cd096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/staff/views/staffPermission.vue"
export default component.exports